import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import HamburgerMenuIcon from "domain/public/Landing/Menu/HamburgerMenu";
import MenuItem from "./MenuItem";
import { spacing } from "globalStyles";
import { MenuDeviceProps } from ".";

const MenuSmallDevices = ({ menus }: MenuDeviceProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    const newState = !isOpen;

    setIsOpen(newState);
  };

  return (
    <Container isOpen={isOpen}>
      <Wrapper>
        <MenuIconWrapper>
          <HamburgerMenuIcon isOpen={isOpen} setIsOpen={toggleOpen} />
        </MenuIconWrapper>
        <Menu isOpen={isOpen}>
          {menus.map((menu) => (
            <MenuItemContainer key={menu.label} onClick={toggleOpen}>
              <MenuItem {...menu} />
            </MenuItemContainer>
          ))}
        </Menu>
      </Wrapper>
      {isOpen && <GlobalStyle />}
    </Container>
  );
};

export default MenuSmallDevices;

const Container = styled.div<{ isOpen: boolean }>`
  position: absolute;
  z-index: 1;
  width: 100%;
  top: 0;
  display: flex;

  ${({ isOpen, theme }) =>
    isOpen &&
    `
      background-color: ${theme.colors.menu.background};
      min-height: 100vh;
    `};
`;

const Wrapper = styled.div`
  padding: ${spacing.large}px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const MenuIconWrapper = styled.div`
  margin-left: auto;
`;

const Menu = styled.div<{ isOpen: boolean }>`
  margin-top: -30px;
  display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;

const MenuItemContainer = styled.div`
  padding: 3vh 0;
`;

const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: hidden;
  }
`;
